import { Injectable } from '@angular/core';
import {ApiService} from '../../core/service/api.service';
import {Observable} from 'rxjs/Observable';
import {isObject} from 'util';

@Injectable()
export class MiscelaneaService {

    private portalResponses = [];

    constructor(private api: ApiService) { }

    findLangPortals(): Observable<any> {
        return this.api.get('portals/common');
    }

    findLangs(): Observable<any> {
        return this.api.get('portals/common/only-lang');
    }

    findPhonePossibleResponses(data: Object, query: string): Observable<any> {
        return this.api.get('vna/stats-config/possible-responses', data);
    }

    findAllPhonePossibleResponses(data: Object, query: string): Observable<any> {
        return this.api.get('vna/stats-config/all-possible-responses', data);
    }

    findAvailableStatus(): Observable<any> {
        return this.api.get('misc/vna/phone-response-status');
    }

    findAllowedVars(portal: string, campName: string): Observable<any> {
        return this.api.get('misc/vna/' + portal + '/vars-allowed', {'name_camp' : campName});
    }

    checkRedisKey(key: string, engine: string = 'master'): Observable<any> {
        return this.api.get('misc/check-redis-key', {'key' : key, 'engine' : engine });
    }

    checkProgress(key: string, engine: string = 'master'): Observable<any> {
        return this.api.get('misc/check-progress-key', {'key' : key, 'engine' : engine });
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/services/miscelanea.service.ts